import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Transition } from 'react-transition-group'
import { Logo, NavLink } from 'src/components'
import { mergeProps } from 'src/util'
import { LocalSettingsContext } from 'src/contexts'
import styles from './SidebarHeader.scss'

/**
 * An animated NavLink containing the sidebar header component.
 */
const SidebarHeader = ({ collapsedContent, children, ...props }) => {
  const { isSidebarCollapsed } = LocalSettingsContext.use()

  return (
    <NavLink {...mergeProps()({ className: styles.header }, props)}>
      <Transition in={isSidebarCollapsed} timeout={300}>
        {state =>
          state === 'entered' ? (
            collapsedContent
          ) : (
            <div className={classnames(styles.content, { [styles.hiding]: state === 'entering' })}>{children}</div>
          )
        }
      </Transition>
    </NavLink>
  )
}

SidebarHeader.defaultProps = {
  to: '/',
  collapsedContent: (
    <Logo
      className={styles.collapsedContent}
      primaryColor="white"
      secondaryColor="white"
      companyColor="white"
      withBrand={false}
    />
  ),
  children: 'Biomérieux',
}

SidebarHeader.propTypes = {
  /**
   * The navlink destination (usually the home page).
   */
  to: PropTypes.string,
  /**
   * The content displayed when the sidebar is collapsed.
   */
  collapsedContent: PropTypes.node,
  /**
   * A component representing the header.
   */
  children: PropTypes.node,
}

export default SidebarHeader
